import { render } from "./EditPharmacy.vue?vue&type=template&id=67833e26&scoped=true"
import script from "./EditPharmacy.vue?vue&type=script&lang=js"
export * from "./EditPharmacy.vue?vue&type=script&lang=js"

import "./EditPharmacy.vue?vue&type=style&index=0&id=67833e26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67833e26"]])

export default __exports__